export default __webpack_public_path__ + "assets/easytime.4b1bf65c.jpg";